export default __webpack_public_path__ + "static/media/multiple-pdf.c561ce81.svg";